import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Container, TextField, Typography } from "@material-ui/core";
import "../AdminCommonPages.css";
import "./Article.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import useFetch from "../../../../../hooks/useFetch";
import uploadPhoto from "../../../../../Image/upload 1.png";
import DeleteIcon from "@material-ui/icons/Delete";

const EditArticle = ({ isShaws }) => {
  const AR = process.env.REACT_APP_PUBLIC_FOLDER;
  const [article, setArticle] = useState({
    desc: undefined,
  });
  const [desc, setDesc] = useState("");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const handleChange = (e) => {
    setArticle((prv) => ({
      ...prv,
      [e.target.id]: e.target.value,
    }));
  };
  const { data, loading, error } = useFetch(
    `https://abc-backend.onrender.com/api/articles/${id}`
  );
  const notify = () => {
    toast.success("Successfully Added !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  useEffect(() => {
    if (data) {
      data.title && setTitle(data.title);
      data.desc && setDesc(data.desc);
    }
  }, [data]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    let newData = {
      title,
      desc,
    };
    if (file) {
      const article = new FormData();
      const fileName = Date.now() + file.name;
      article.append("name", fileName);
      article.append("file", file);
      newData.image = fileName;
      if (newData.image) {
        newData.image = data.image;
      }
      try {
        await axios.post(
          "https://abc-backend.onrender.com/api/upload",
          article
        );
      } catch (err) {}
    }
    try {
      //abc-backend.onrender.com/api/articles/image
      await axios
        .put(`https://abc-backend.onrender.com/api/articles/${id}`, newData)
        .then((res) => {
          if (res.data) {
            notify();
            navigate("/siteadmin/article");
            window.location.reload();
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleDelete = async (img) => {
    console.log(img);
    const imgdata = { img };
    try {
      await axios.post("https://abc-backend.onrender.com/api/uploads", imgdata);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className="edit_article_main" style={{ marginTop: "80px" }}>
      {loading ? (
        "loadding"
      ) : (
        <Container>
          <Typography variant="h2">Edit Article</Typography>
          <Box>
            <form
              noValidate
              autoComplete="off"
              className="type_form"
              onSubmit={handleSubmit}
            >
              <div className="upload_img_init">
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="image"
                  type="file"
                  name="image"
                  onChange={(e) => setFile(e.target.files[0])}
                />
                <label htmlFor="image" className="upload_img_text">
                  <img
                    src={data.image ? AR + data.image : uploadPhoto}
                    alt="uploadPhoto"
                    className="uploading_img"
                  />
                  <span>Add image</span>
                </label>
                {/* <span
                  className="delect_icon"
                  onClick={() => handleDelete(data.image)}
                >
                  <DeleteIcon />
                </span> */}
              </div>
              <Box>
                <label htmlFor="">Article Title</label>
                <br />
                <br />
                <TextField
                  variant="outlined"
                  id="title"
                  defaultValue={data.title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Box>
              <Box>
                <label htmlFor="">Article Description</label>
                <br />
                <br />
                <TextField
                  variant="outlined"
                  id="desc"
                  defaultValue={data.desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
              </Box>
              <Box className="type_submit_btn">
                <button className="common-btn" type="submit">
                  Update
                </button>
              </Box>
            </form>
          </Box>
          <ToastContainer />
        </Container>
      )}
    </div>
  );
};

export default EditArticle;
